import { RELEASE_NOTES } from 'app/api-routes';
import axios from 'axios';
import { all, put, select, takeLatest } from 'redux-saga/effects';
import * as settings from 'ducks/settings';

import { releaseNotesFailure, releaseNotesRequest, releaseNotesSuccess } from './actions';

function* releaseNotesRequestSaga({ payload: { lastSeenID } = {} }) {
  try {
    const settingsState = yield select(settings.selectors);
    const lang = settingsState && settingsState.locale && settingsState.locale.locale;

    const params = {};
    if (lang) params.lang = lang;
    if (lastSeenID) params.lastSeenID = lastSeenID;

    const { payload: items } = yield axios.get(RELEASE_NOTES, { params });

    yield put(releaseNotesSuccess(items || []));
  } catch (err) {
    yield put(releaseNotesFailure(err));
  }
}

export default function* () {
  yield all([yield takeLatest(releaseNotesRequest, releaseNotesRequestSaga)]);
}
